module.exports = __webpack_public_path__ + "img/virgin-logo.a4614e1b.svg";